import {RecipeContext} from './order.store';

export enum SelectionControl {
  RadioButtonList = 1,
  Slider = 2,
  Stepper = 3
}

export class PriceEntity {
  effectiveUtc: string;
  entityId: number;
  entityType: string;
  price: number;
  recipeTypesBitwise: number;
}

export class EntityPrices {
  concurrencyStamp: string;
  prices?: (PriceEntity)[] | null;
  recipeTypeMap?: (Number)[] | null;
}

export class ChildRecipeResponse {
  ingredients?: (IngredientsEntity)[] | null;
  locationEntityPrices?: (EntityPrices)[] | null;
  recipe?: ChildRecipeEntity | null;
}
export class MultiChildRecipeResponse {
  ingredients?: (IngredientsEntity)[] | null;
  recipes?: (ChildRecipeEntity)[] | null;
  quantity?: number | null;
}

export interface ParentRecipeEntity {
  menuNumber?: number | null;
  recipes?: (ChildRecipeEntity | null)[] | null;
  isLTO?: boolean | false;
  title: string;
  id: number;
  slug: string;
  name: string;
  description?: string | null;
  longDescription?: string | null;
  imageUrl?: string | null;
  subTitle?: string | null;
  isHighCalories?: boolean | null;
  ingredients?: string | null;
  customizationMatrix: CustomizationMatrix;
  hasDrink?: boolean | null;
  groupPrices?: (GroupPricesEntity)[] | null;
  associatedItems?: (number)[] | null;
  regionalDisclaimer?: string | null;
  startTime?: string | null;
  endTime?: string | null;
  hasSide?: boolean | null;
  sortIndex: number;
  altText?: string;
}

export class IngredientsEntityOrIngredient {
  id: number;
  ingredientId: number;
  multiplier: number;
  name: string;
  slug: string;
  nutritionInfo: NutritionInfo;
  allergens?: (AllergensEntity)[] | null;
}

export class CustomizationMatrix {
  customizationGroups?: (CustomizationGroupsEntity | null)[] | null;
  groupIncompatibilities?: (GroupIncompatibilitiesEntity)[] | null;
}

export class GroupIncompatibilitiesEntity {
  modifierGroupId: number;
  incompatibleModifierGroupIds?: (number)[] | null;
}

export class IngredientMultiplier {
  ingredientId: number;
  multiplier: number; // made optional
  isProminent: boolean;
}

export class AssociatedItem {
  id: number;
  name: string;
  description?: string | null;
  imageUrl?: string | null;
  type: number;
}

export class ChildRecipeEntity {
  longDescription: string;
  startTime: string;
  ingredients?: (IngredientMultiplier)[] | null;
  ingredientsDescription: string;
  customizationGroups: (CustomizationGroupsEntity)[] | null;
  // customizations: (CustomizationGroupsEntity)[] | null; // to match order submit request
  prices: (GroupPricesEntity)[] | null;
  isDefaultChild: boolean;
  id: number;
  slug: string;
  name: string;
  description: string;
  imageUrl: string;
  subTitle: string;
  whatsOnIt: string;
  mealIncludes: string;
  ingredientsList?: (IngredientsEntity)[] | null;
  selectedScreen: number;
  recipeBasicInfo: RecipeBasicInfo | null;
  isWhatasizeApplied: boolean;
  recipeTypeId: number;
  associatedItems?: (AssociatedItem)[] | null;
  comesWithText: string;
  totalCalories: number;
  totalPrice: number;
  hasDrink: boolean;
  hasSide: boolean;
  categoryName: string;
  categorySlugName: string;
  quantity: number;
  clientId: string;
  categoryId: number;
  recipeId: number;
  customName: string;
  useReward: boolean;
  offerId: number;
  useWhatASize: boolean;
  isRecipeNotAvailable: boolean;
  isDrinksNotAvailable: boolean;
  availability: Availability;
  orderItemId: number;
  isOfferAdded: boolean | false;
  isOfferDrinkPopupReq: boolean | false;
  isOfferSidePopupReq: boolean | false;
  offerCouponCode: Number | null;
  isAttachToOffer: boolean | false;
  offerFlag: boolean | false;
  parentRecipeId: Number;
  groupIncompatibilities: (GroupIncompatibilities)[] | null;
  UnavailableModifierGroups: string;
  nonExistentModifierGroups?:NonExistentModifierGroups[];
  nonExistentModifiers?: NonExistentModifiers[];
  unAvailableModifierGroupModifierIds?: ModifierGroupIdModifierId[];
  unAvailableModifiers?: ModifierDetails[];
  nonExistentSpecialInstructions?: NonExistentSpecialInstructions[];
  ariaWhatsOnIt?: string;
  isRecipeNonExistent: boolean;
  isOversize: boolean;
  modifierGroupsWithServeRestrictions: ModifierGroupsEntity[];
  context?: RecipeContext = RecipeContext.CHILD;
  isUpsell?: boolean;
  linkedRecipe?: ChildRecipeEntity;
  includesDescription?: string;
  hideFromMealSelection?: boolean;
  recipeNotAvailableInTimeStampErrorMessage?: string;
  comesWithTextWeb?: string;
  webImageUrl?: string;
}
export interface ModifierGroupIdModifierId {
  modifierGroupId: number;
  modifierId: number;
}
export class GroupIncompatibilities {
  modifierGroupId?: number | null;
  incompatibleModifierGroupIds?: (number)[] | null;
}

export class RecipeBasicInfo {
  isHighCalories: boolean;
  longDescription: string;
  parentRecipeId: number;
  parentRecipeName: string;
  price: number;
  startTime: string;
  endTime: string;
  whatASizable: boolean;
}

export class IngredientsEntity {
  multiplier?: number;
  id: number;
  name: string;
  slug: string;
  allergens?: (AllergensEntity)[] | null;
  nutritionInfo: NutritionInfo;
}

export class NutritionInfo {
  calories?: number | null;
  weight?: number | null;
  weightUOM?: string | null;
  caloriesUOM?: string | null;
  sodium?: number | null;
  sodiumUOM?: string | null;
  carbs?: number | null;
  carbsUOM?: string | null;
  dietaryFiber?: number | null;
  dietaryFiberUOM?: string | null;
  protein?: number | null;
  proteinUOM?: string | null;
  sugars?: number | null;
  sugarsUOM?: string | null;
  vitaminA?: number | null;
  vitaminAUOM?: string | null;
  vitaminC?: number | null;
  vitaminCUOM?: string | null;
  calcium?: number | null;
  calciumUOM?: string | null;
  iron?: number | null;
  ironUOM?: string | null;
  totalFatUOM?: string | null;
  caloriesFromFatUOM?: string | null;
  totalFat?: number | null;
  transFatUOM?: string | null;
  saturatedFat?: number | null;
  saturatedFatUOM?: string | null;
  transFat?: number | null;
  cholesterol?: number | null;
  cholesterolUOM?: string | null;
  caloriesFromFat?: number | null;
  potassium?: number | null;
  potassiumUOM?: string | null;
  phosphorous?: number | null;
  phosphorousUOM?: string | null;
  units?: {
    servings?:number | null;
  }
}
export class AllergensEntity {
  slug: string;
  name: string;
}

export class CustomizationGroupsEntity {
  id: number;
  name: string;
  displayText: string;
  maxSelection?: number | null;
  isMultiSelect?: boolean | null;
  type: number;
  modifierGroups?: (ModifierGroupsEntity)[] | null;
  screenNumber?: (number | null);
  hasNoneSelectionGroup?: boolean; // has made optional due to unavailability of data
  noneSelectionGroupName?: string;
  sortIndex: number;
  modifierGroupId: number;
  modifierId: number;
  specialInstructionIds?: (number)[];
  customizationGroupId: number | null;
  canOverride: boolean | false;
  customizationSubGroups: (CustomizationSubGroupEntity)[] | null;
  ariaLabel?: string;
  isUpsell?: boolean;
  minimumQuantity?: number;
  maximumQuantity?: number;
  disableCopyCustomizations?: boolean;
}
export enum CustomizationGroupType {
  Side	= 1,
  Drink	= 2,
  DippingSauces	= 3,
  Other	= 10
}
export enum CustomizationGroupTypeDisplayValue {
  Side	= 'Side',
  Drink	= 'Drink',
  DippingSauces	= 'Dipping-Sauces',
  Other	= 'Other'
}

export class CustomizationSubGroupEntity {
  customizationSubGroupId: number;
  name: string;
  modifierGroupIds: (number)[] | null;
  quantity: number;
  modifierGroup: ModifierGroupsEntity;
  modifier: ModifiersEntity;
  sortOrder: number;
  modifierUnitPrice: number;
  subPrice: number;
  discountAmount: number;
  subQuantity: number;
}

export class ModifierGroupsEntity {
  id: number;
  name: string;
  displayText?: string | null;
  imageUrl?: string | null;
  sortIndex: number;
  selectionControl?: number | null;
  whatASizable?: boolean;
  modifiers?: (ModifiersEntity)[] | null;
  isRequired?: boolean; // made Optional
  isDefaultSelected?: boolean; // Optional
  isSelected?: boolean;
  selectedModifier?: any;
  specialInstructionId?: (number)[] | null;
  modiferNotAvailable: boolean;
  availability: Availability;
  isDisabled?: boolean;
  ariaLabel?: string;
  serveStartTime?: string;
  serveEndTime?: string;
  linkedRecipeId?: number;
  linkedRecipeIncludeUpsell?: boolean;
  isWebDefaultSelected?: boolean;
}

export function isModifierGroupDefaultSelected(modifierGroup: ModifierGroupsEntity, customizationGroup?: CustomizationGroupsEntity): boolean {
  if (!customizationGroup) {
    return modifierGroup.isWebDefaultSelected === true || modifierGroup.isDefaultSelected === true;
  }

  return customizationGroup.modifierGroups?.some(mg => mg.isWebDefaultSelected === true)
    ? modifierGroup.isWebDefaultSelected === true 
    : modifierGroup.isDefaultSelected === true;
}

export class Availability {
  effective?: string | null;
  expiry?: string | null;
}

export class ModifiersEntity {
  id: number;
  name: string;
  displayText?: string | null;
  imageUrl?: string | null;
  isInvalid?: boolean;
  ingredients?: (IngredientMultiplier | null)[] | null;
  price?: number | null;
  sortIndex?: number | null;
  isSelected?: boolean;
  specialInstructions?: (SpecialInstructionsEntity)[] | null;
  isDefaultSelected?: boolean; // made Optional
  specialInstructionsModifier?: (SpecialInstructionModifier)[] | null;
  unitPrice: number | 0;
  subUnitPrice: number | 0;
  quantity?: number;
  subQuantity?: number | 0;
  ariaLabel?: string;
  intrinsicQuantity?: number;
  summaryDescription?: string;
  selectedChildRecipeId?: number;
}

export class GroupPricesEntity {
  amount?: number | null;
  effective: string;
  expiry?: string | null;
  isLTO?: boolean | null;
}

export class SpecialInstructionsEntity {
  id: number;
  name: string;
  displayText?: string | null;
  isEnabled?: boolean | null;
  ingredients?: (IngredientMultiplier | null)[] | null;
  sortIndex?: number | null;
  itemIds: (number)[] | null;
}

export class ModifierValue {
  modifierGroupId: any;
  custGroupId: any;
  value: any;
}

export class SelectedModifierGroupValue {
  modifierGroupId: any;
  isSelected: any;
}

export class ModifierGroupCalPriceCalories {
  modifierGroupId: any;
  custGroupId: any;
  isDefaultmodifier: any;
  calPrice: any;
  calories: any;
  perServing?:number;
}

export class SpecialInstructionModifier {
  modifierId: any;
  specialInstructionId?: (number)[] | null;
}
export class SelectedModifiers {
  orderItemId: number;
  ModifierName: string;
}
export class SelectedRecipes {
  orderItemId: number;
  RecipeName: string;
}
export class UnavailableModifierGroups {
  orderItemId: number;
  modifierGroupId: number;
  recipeId: number;
  modifierId?: number;
}
export class NonExistentModifierGroups extends UnavailableModifierGroups {
  name: string;
  modifierDisplayText?: string;
}
export class NonExistentModifiers extends NonExistentModifierGroups {
  modifierId: number;
  customizationGroupId: number;
  quantity?: number;
  displayText?: string;
  modifierGroupName?: string;
}
export class NonExistentSpecialInstructions extends NonExistentModifiers {
  specialInstructionId: number;
}
export class UnavailableRecipes {
  recipeId: number;
}
export class ModiferGroupsNotAvailable {
  modifierGroupId: number;
  modifierGroupName: string;
}
export interface ModifierGroupResponse {
  modifierGroups: ModifierGroupDetails[];
}

export interface ModifierGroupDetails extends PresentableObject {
  isPublished?: boolean;
}

export interface ModifierGroupDetailsModifier extends ModifierGroupDetails {
  modifierId: number | null;
}
export interface ModifierDetails extends PresentableObject {
  isPublished: boolean;
  quantity? : number;
  modifierGroups: ModifierGroupDetails[];
}
export interface ModifierResponse {
  modifiers: ModifierDetails[];
}

export interface PresentableObject {
  id: number;
  slug: string;
  name: string;
  displayText: string;
  description: string;
  imageUrl: string;
  subTitle: string;
  sortIndex: number;
}
export interface SpecialInstructionResponse {
  specialInstructions: SpecialInstructionDetails[];
}
export interface SpecialInstructionDetails extends PresentableObject {
  isPublished: boolean;
  modifiers: ModifierDetails[];
}
export interface OrderRecipeBasicInfo {
  recipeId: number;
  name: string;
  imageUrl: string;
  isPublished: boolean;
}

export interface OrderModifierBasicInfo {
  modifierGroupId: number;
  modifierGroupName: string;
}
